module.exports = __webpack_public_path__ + "img/sec_3_box1.091d8a54.png";